/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './removeReaction.defs.js'
export * as $defs from './removeReaction.defs.js'
